angular.module("avant.customer_applications.controllers").controller "CustomerApplicationsPaymentDetailsCtrl", [
  '$scope'
  '$http'
  '$window'
  '$modal'
  'page_data'
  'DirectDebitService'
  ($scope, $http, $window, $modal, page_data, DirectDebitService) ->

    angular.extend $scope,
      ddi: {}
      customer_data: {}
      debit_card: {}
      direct_debit_instruction_tab: active: false
      debit_card_tab: active: false
      attempt_validate: false
      submit_status: 'unconfirmed'
      success_location: "/customer/home?customer_application_id=#{page_data.customer_data.customer_application_id}"
      page_data.config

    if $scope.direct_debit_enabled
      $scope.direct_debit_instruction_tab.active = true
    else if !$scope.debit_card_locked_out
      $scope.debit_card_tab.active = true

    angular.extend $scope.ddi, page_data.model_data
    angular.extend $scope.customer_data, page_data.customer_data

    $scope.alertAdmin = ->
      alert "Admin Users cannot complete this action!"

    $scope.onlyCustomers = (callback) ->
      if $scope.current_admin_user
        $scope.alertAdmin()
      else
        callback()

    $scope.validateForms = ->
      $scope.attempt_validate = true
      if $scope.validate_debit_card_form() || $scope.validate_ddi_form()
        if $scope.forms.direct_debit_consent_form.$valid
          $scope.submit()

    $scope.validate_debit_card_form = ->
      if $scope.debit_card_tab.active
        if $scope.forms.debit_card_form.$valid
          return true
        else
          angular.forEach $scope.forms.debit_card_form.$error.required, (item) ->
            item.$setViewValue item.$viewValue
          return false

    $scope.validate_ddi_form = ->
      if $scope.direct_debit_instruction_tab.active
        if $scope.forms.ddi_form.$valid
          return true
        else
          angular.forEach $scope.forms.ddi_form.$error.required, (item) ->
            item.$setViewValue item.$viewValue
          return false

    $scope.submit = ->
      $scope.onlyCustomers ->
        $scope.submitDisabled = true
        if $scope.direct_debit_instruction_tab.active
          $scope.openSubmitModal()
        else
          $scope.debit_card_form_error = null
          DirectDebitService
            .debit_card_submit($scope.debit_card)
              .then(
                (data) =>
                  $window.location.replace $scope.success_location
                (error) =>
                  $scope.submitDisabled = false
                  if error.message
                    $scope.debit_card_form_error = error.message
                  else
                    $scope.debit_card_form_error = 'Your request could not be completed. Please try again.'
              )

    $scope.openGuaranteeModal = ->
      modalInstance = $modal.open(
        templateUrl: "/shared/direct_debit_guarantee.html"
        controller: [
          "$scope", "$modalInstance", ($scope, $modalInstance) ->
            $scope.close = ->
              $modalInstance.dismiss('cancel')
        ]
        windowClass: 'guarantee-modal'
      )

    $scope.openSubmitModal = ->
      modalInstance = $modal.open(
        resolve:
          submit_status:()->
            $scope.submit_status
          success_location:()->
            $scope.success_location
          customer_data:() ->
            $scope.customer_data
          ddi:()->
            $scope.ddi
        templateUrl: "/direct_debit_authorization/direct_debit_submit_modal.html"
        controller: [
          "$scope", "$modalInstance", "submit_status", "success_location", "customer_data", "ddi",
          ($scope, $modalInstance, submit_status, success_location, customer_data, ddi) ->
            $scope.submit_status = submit_status
            $scope.success_location = success_location
            $scope.customer_data = customer_data
            $scope.ddi = ddi

            $scope.cancel = ->
              modalInstance.close()
            $scope.confirm = ->
              $scope.submit_status = 'submitted'
              DirectDebitService
                .ddi_submit({ direct_debit_auth: angular.extend($scope.ddi, { signed_on: String(Date()) }) })
                  .then(
                    (data) =>
                      $scope.submit_status = 'submit_success'
                    (error) =>
                      $scope.submit_status = 'submit_failed'
                  )
            $scope.continue = ->
              $window.location.replace $scope.success_location
        ]
        backdrop:    'static'
        keyboard:    false
        windowClass: 'submit-modal'
        animation: false
      )

      modalInstance.result.then(()->
        $scope.submitDisabled = false
        $scope.submit_status = 'unconfirmed'
      )
]
